<template>
    <el-dialog :append-to-body="true" :visible.sync="myVisible" custom-class="xes-question-error" top="0" title="报错" :close-on-click-modal="false" v-drag>
        <div class="reportError-row">
            <label class="title">错误位置：</label>
            <el-checkbox-group v-model="errorActive">
                <el-checkbox v-for="(value, key) in errorType" :label="key" :key="key">{{ value }}</el-checkbox>
            </el-checkbox-group>
        </div>
        <div class="reportError-row">
            <label class="title">错误描述：</label>
            <div class="xes-ckEdtior">
                <ckEdtior
                    v-if="myVisible && secret"
                    :url="actions.uploadImg"
                    latex
                    v-model="content"
                    placeholder="请输入错误描述，1000字以内，图片大小不能超过2M。"
                    :params="{ secret: secret }"
                ></ckEdtior>
            </div>
        </div>
        <div class="reportError-row">
            <label class="title">上传文件：</label>
            <el-upload
                v-if="myVisible"
                class="xes-questionError-upload"
                :data="{ secret: secret }"
                ref="upload"
                :action="actions.uploadAttachment"
                :multiple="false"
                :limit="1"
                :before-upload="fileBefore"
                :on-success="fileSuccess"
                :on-remove="fileRemove"
            >
                <button class="upload-btn">添加附件</button>
                <p class="upload-tip" slot="tip">文件名只允许数字,字母,下划线与中文,且不超过50m</p>
            </el-upload>
            <!-- <xes-upload
                v-if="myVisible"
                :action="actions.uploadAttachment"
                :accept="option.imgAccept"
                :auto-upload="true"
                :max-size="option.maxSize"
                :onerror="ajaxError"
                :params="{secret:secret}"
            ></xes-upload> -->
        </div>
        <el-button size="small" type="primary" @click="reportErrorSubmit" :disabled="!errorActive.length || !content">报错</el-button>
    </el-dialog>
</template>

<script>
import ckEdtior from './ckEdtior'
import { httpRequest } from '../../../src/utils/ajax'
export default {
    name: 'xes-question-error',
    props: {
        visible: {
            default: false
        },
        actions: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        },
        question_id: {
            type: [String, Number],
            required: true
        },
        source: {
            type: [String, Number],
            required: true
        },
        create_id: {
            type: [String, Number],
            required: true
        },
        create_name: {
            type: String,
            required: true
        },
        create_email: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            errorType: [],
            errorActive: [],
            content: '',
            uploadImgUrl: '',
            option: {
                imgAccept:
                    'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,audio/mp3,application/x-zip-compressed,application/octet-stream', // 设置sccept
                maxSize: 5 * 1024 * 1024 // 设置文件最大限制
            },
            file_path: '',
            secret: ''
        }
    },
    created() {
        this.getSecret()
    },
    methods: {
        throwError(action) {
            // 若无相关地址，抛出错误
            if (!this.actions[action]) {
                throw new Error(`${action}地址为空！`)
            }
            return true
        },
        getCookie(name) {
            if (document.cookie.length > 0) {
                var start = document.cookie.indexOf(name + '=')
                if (start != -1) {
                    start = start + name.length + 1
                    var end = document.cookie.indexOf(';', start)
                    if (end == -1) {
                        end = document.cookie.length
                    }
                    return unescape(document.cookie.substring(start, end))
                }
            }
            return ''
        },
        reportErrorSubmit() {
            const isActionNotPass = this.throwError('add')
            if (!isActionNotPass) return
            let params = {
                question_id: this.question_id,
                error_ids: this.errorActive.join(','),
                error_desc: this.content,
                resource_type: this.source,
                create_id: this.create_id,
                create_name: this.create_name,
                create_email: this.create_email,
                file_path: this.file_path,
                secret: this.secret
            }
            var option = {
                method: 'POST',
                params: params,
                action: this.actions.add
            }
            httpRequest(option)
                .then(res => {
                    if (res.status == 100) {
                        this.viewHide()
                        this.ajaxSuccess({ ...res, flag: 'add' })
                    } else {
                        this.statusError(res)
                    }
                })
                .catch(err => {
                    this.ajaxError(err)
                })
        },
        getSecret() {
            //获取secret
            const isActionNotPass = this.throwError('getSecret')
            if (!isActionNotPass) return
            var option = {
                method: 'POST',
                params: { uuid: this.getCookie('X-Request-Id') },
                action: this.actions.getSecret
            }
            httpRequest(option)
                .then(res => {
                    if (res.status == 100) {
                        this.secret = res.data
                        this.getErrorTypes()
                        this.ajaxSuccess({ ...res, flag: 'getSecret' })
                    } else {
                        this.statusError(res)
                    }
                })
                .catch(err => {
                    this.ajaxError(err)
                })
        },
        getErrorTypes() {
            const isActionNotPass = this.throwError('getConfig')
            if (!isActionNotPass) return
            var option = {
                method: 'POST',
                params: { secret: this.secret },
                action: this.actions.getConfig
            }
            httpRequest(option)
                .then(res => {
                    if (res.status == 100) {
                        this.errorType = res.data.report_error_type
                        this.ajaxSuccess({ ...res, flag: 'getConfig' })
                    } else {
                        this.statusError(res)
                    }
                })
                .catch(err => {
                    this.ajaxError(err)
                })
        },
        viewHide() {
            this.errorActive.splice(0, this.errorActive.length)
            this.content = ''
            this.myVisible = false
        },
        fileBefore(file) {
            let ext = file.name.split('.')
            ext = ext[ext.length - 1].toLowerCase()
            if (!['doc', 'docx', 'xlsx', 'xls', 'zip', '7z', 'rar', 'mp3', 'MP3', 'txt'].includes(ext)) {
                this.$message.error('请上传doc、docx、xlsx、xls、zip、7z、rar、mp3、txt等格式的文件!', 'error')
                return false
            }
            let reg = /^[a-zA-Z0-9_\.\u4e00-\u9fa5]+$/
            if (!reg.test(file.name)) {
                this.$message.error('文件名只允许数字,字母,下划线与中文', 'error')
                return false
            }
            let limit = 50 * 1024 * 1024
            if (file.size > limit) {
                this.$message.error('上传文件不能大于' + 50 + 'MB!', 'error')
                return false
            }
            return true
        },
        fileSuccess(res, file, fileList) {
            if (res.status == 100) {
                this.file_path = res.data
                this.ajaxSuccess({ ...res, flag: 'uploadImg' })
            } else {
                this.file_path = ''
                fileList.splice(0, fileList.length)
                this.$message.error(res.data, 'error')
            }
        },
        fileRemove() {
            this.file_path = ''
        },
        statusError(data) {
            console.log(data)
            this.$emit('status-error', data)
        },
        ajaxError(data) {
            console.log(data)
            this.$emit('ajax-error', data)
        },
        ajaxSuccess(data) {
            console.log(data)
            this.$emit('ajax-success', data)
        }
    },
    computed: {
        myVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            }
        }
    },
    components: {
        ckEdtior
    },
    directives: {
        drag: {
            bind(el) {
                var Drag = el.querySelector('.xes-question-error .el-dialog__header')
                var Box = el.querySelector('.xes-question-error')
                Drag.onmousedown = function(event) {
                    var ev = event || window.event
                    event.stopPropagation()
                    var disX = ev.clientX - Box.offsetLeft
                    var disY = ev.clientY - Box.offsetTop
                    document.onmousemove = function(event) {
                        var ev = event || window.event
                        Box.style.left = ev.clientX - disX + 'px'
                        Box.style.top = ev.clientY - disY + 'px'
                        Drag.style.cursor = 'move'
                    }
                }
                Drag.onmouseup = function() {
                    document.onmousemove = null
                    this.style.cursor = 'default'
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// packages/question-error/src/index.vue